// extracted by mini-css-extract-plugin
export default {"mobileMenuHeader":"rdlOFy","closeIconOuter":"GlSIqb"};